import { BlueprintActions } from '../actions';
import type { IBlueprintManagementState } from '../appstate';
import * as GeneralReducers from './GeneralReducers';

const initialState: IBlueprintManagementState = {
	blueprints: {
		payload: [],
		inProcess: false,
		error: false,
		totalPages: 0,
		totalResults: 0,
	},
	blueprint: {
		payload: null,
		inProcess: false,
		error: false,
	},
	locations: {
		payload: [],
		inProcess: false,
		error: false,
	},
	suppliers: {
		payload: [],
		inProcess: false,
		error: false,
	},
	massImportInProgressForCustomer: {
		payload: null,
		inProcess: false,
		error: false,
	},
	deleteModal: {
		isOpen: false,
	},
	deletingBlueprint: {
		inProcess: false,
		error: false,
	},
	savingEditMasterOrderGuide: {
		inProcess: false,
		error: false,
	},
	savingNewMasterOrderGuide: {
		inProcess: false,
		error: false,
	},
	savingMassImportRequest: {
		inProcess: false,
		error: false,
	},
	currentPage: 1,
	supplierFilterId: 0,
	locationFilterIds: [],
	customerNote: '',
};

export const _childReducers = {
	blueprintReducer: GeneralReducers.CreateLoaderReducer({
		startAction: BlueprintActions.LOADING_BLUEPRINT,
		clearPayloadWith: initialState.blueprint.payload,
	}),
	suppliersLoaderReducer: GeneralReducers.CreateLoaderReducer({
		startAction: BlueprintActions.LOADING_SUPPLIERS,
		clearPayloadWith: initialState.suppliers.payload,
	}),
	massImportInProgressForCustomerReducer: GeneralReducers.CreateLoaderReducer({
		startAction: BlueprintActions.LOADING_MASS_IMPORT_IN_PROGRESS,
		clearPayloadWith: initialState.massImportInProgressForCustomer.payload,
	}),
	submitMassImportReducer: GeneralReducers.CreateAsynchronousActionReducer({
		startAction: BlueprintActions.SUBMIT_MASS_IMPORT_REQUEST,
	}),
	submitBlueprintReducer: GeneralReducers.CreateAsynchronousActionReducer({
		startAction: BlueprintActions.SUBMIT_BLUEPRINT,
	}),
	editBlueprintReducer: GeneralReducers.CreateAsynchronousActionReducer({
		startAction: BlueprintActions.EDIT_BLUEPRINT,
	}),
};

export function blueprintManagementReducer(
	state = initialState,
	action
): IBlueprintManagementState {
	switch (action.type) {
		case BlueprintActions.LOADING_BLUEPRINT:
		case BlueprintActions.LOADING_BLUEPRINT_SUCCESS:
		case BlueprintActions.LOADING_BLUEPRINT_ERROR:
			return {
				...state,
				blueprint: _childReducers.blueprintReducer(state.blueprint, action),
			};
		case BlueprintActions.LOADING_SUPPLIERS:
		case BlueprintActions.LOADING_SUPPLIERS_SUCCESS:
		case BlueprintActions.LOADING_SUPPLIERS_ERROR:
			return {
				...state,
				suppliers: _childReducers.suppliersLoaderReducer(
					state.suppliers,
					action
				),
			};
		case BlueprintActions.SUBMIT_BLUEPRINT:
		case BlueprintActions.SUBMIT_BLUEPRINT_SUCCESS:
		case BlueprintActions.SUBMIT_BLUEPRINT_ERROR:
			return {
				...state,
				savingNewMasterOrderGuide: _childReducers.submitBlueprintReducer(
					state.savingNewMasterOrderGuide,
					action
				),
			};
		case BlueprintActions.EDIT_BLUEPRINT:
		case BlueprintActions.EDIT_BLUEPRINT_SUCCESS:
		case BlueprintActions.EDIT_BLUEPRINT_ERROR:
			return {
				...state,
				savingEditMasterOrderGuide: _childReducers.editBlueprintReducer(
					state.savingEditMasterOrderGuide,
					action
				),
			};
		case BlueprintActions.SUBMIT_MASS_IMPORT_REQUEST:
		case BlueprintActions.SUBMIT_MASS_IMPORT_REQUEST_SUCCESS:
		case BlueprintActions.SUBMIT_MASS_IMPORT_REQUEST_ERROR:
			return {
				...state,
				savingMassImportRequest: _childReducers.submitMassImportReducer(
					state.savingMassImportRequest,
					action
				),
			};
		case BlueprintActions.LOADING_MASS_IMPORT_IN_PROGRESS:
		case BlueprintActions.LOADING_MASS_IMPORT_IN_PROGRESS_SUCCESS:
		case BlueprintActions.LOADING_MASS_IMPORT_IN_PROGRESS_ERROR:
			return {
				...state,
				massImportInProgressForCustomer:
					_childReducers.massImportInProgressForCustomerReducer(
						state.massImportInProgressForCustomer,
						action
					),
			};
		// TODO(chrisw): typing
		case '@ca:SELECTED_CUSTOMER_PENDING':
			return {
				...state,
				currentPage: initialState.currentPage,
				suppliers: initialState.suppliers,
				supplierFilterId: initialState.supplierFilterId,
			};
	}

	return state;
}
